import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../../../constants/styles'
import MeetingSidebar from '../components/MeetingSidebar'
import VideoCall from '../../videocall/views/VideoCall'
import {
    fetchMeetingVideocall,
    selectCurrentMeeting
} from '../currentMeetingSlice'
import useSlug from '../../../hooks/useSlug'
import colors from '../../../constants/colors'
import useFetchAttendees from '../../attendees/useFetchAttendees'
import { formatName } from '../../../utils/profile'
import { selectVideocall } from '../../videocall/videocallSlice'
import PublicChatBar from '../../../components/PublicChatBar'
import Icon from '../../../components/Icon'

const S = {
    Wrapper: styled.div`
        display: flex;
        width: 100%;
        height: 100%;
        overflow: hidden;
    `,
    VideoCallWrapper: styled.div`
        margin-right: ${styles.sidebarWidth}px;
        width: 100%;
        @media (max-width: 1366px) {
            margin-right: ${styles.smallerSidebarWidth}px;
        }
    `,
    Info: styled.div`
        width: 220px;
        overflow: hidden;
    `,
    Name: styled.h3`
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        margin: 0;
        color: white;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
    Description: styled.p`
        font-size: 13px;
        line-height: 16px;
        color: ${colors.gray6};
        max-height: 120px;
        margin: 0%;
    `,
    ActionSidebar: styled.div`
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        right: ${styles.sidebarWidth}px;
        width: 40px;
        height: 48px;
        padding: 12px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        background: white;
        border-left: 1px solid ${colors.gray3};
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;

        @media (max-width: 1366px) {
            right: ${styles.smallerSidebarWidth}px;
        }
    `,
}

const BottomBarContent = () => {
    const meeting = useSelector(selectCurrentMeeting)
    const [host] = useFetchAttendees([meeting?.host_id])
    return (
        <S.Info>
            <S.Name>{host && formatName(host)}</S.Name>
            <S.Description>{meeting?.title}</S.Description>
        </S.Info>
    )
}

const PublicChatSidebar = () => {
    const videocall = useSelector(selectVideocall)
    const [show, setShow] = useState(false)
    if (!videocall?.public_chat_id) {
        return null
    }

    return (
        <>
            <S.ActionSidebar>
                <Icon
                    icon="forum"
                    onClick={() => setShow(!show)}
                />
            </S.ActionSidebar>
            <PublicChatBar
                isShowPublicChat={show}
                chatId={videocall.public_chat_id}
            />
        </>
    )
}

const MeetingVideocall = () => {
    const dispatch = useDispatch()
    const eventSlug = useSlug('eventSlug')
    const meetingSlug = useSlug('meetingSlug')
    const twilioName = useSlug('roomId')

    useEffect(() => {
        dispatch(fetchMeetingVideocall({ eventSlug, meetingSlug, twilioName }))
    }, [dispatch, eventSlug, meetingSlug, twilioName])

    return (
        <S.Wrapper>
            <S.VideoCallWrapper>
                <VideoCall
                    bottomBarContent={
                        <BottomBarContent />
                    }
                />
            </S.VideoCallWrapper>
            <PublicChatSidebar />
            <MeetingSidebar />
        </S.Wrapper>
    )
}

export default MeetingVideocall
